/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Linked_Group_LabelInputs */

const en_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Group`)
};

const fr_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe lié`)
};

const de_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfte Gruppe`)
};

const it_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo collegato`)
};

const ru_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанная группа`)
};

const es_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo vinculado`)
};

const zh_cn2_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接组`)
};

const ja_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクグループ`)
};

const hi_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक्ड ग्रुप`)
};

const pt_pt2_edit_event_group_linked_group_label = /** @type {(inputs: Edit_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo Vinculado`)
};

/**
* | output |
* | --- |
* | "Linked Group" |
*
* @param {Edit_Event_Group_Linked_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_linked_group_label = /** @type {((inputs?: Edit_Event_Group_Linked_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Linked_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_linked_group_label(inputs)
	if (locale === "de") return de_edit_event_group_linked_group_label(inputs)
	if (locale === "it") return it_edit_event_group_linked_group_label(inputs)
	if (locale === "ru") return ru_edit_event_group_linked_group_label(inputs)
	if (locale === "es") return es_edit_event_group_linked_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_linked_group_label(inputs)
	if (locale === "ja") return ja_edit_event_group_linked_group_label(inputs)
	if (locale === "hi") return hi_edit_event_group_linked_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_linked_group_label(inputs)
	return en_edit_event_group_linked_group_label(inputs)
});